var widget_default = {
  "card": "_12voC",
  "link": "gr2hd",
  "container": "DCPvE",
  "image": "L6l0E",
  "right": "ew594",
  "cardLayout": "F29Ja",
  "content": "ZzZ36",
  "title": "Fq3K4",
  "subtitle": "TU8lM",
  "button": "WZK6U",
  "button_disabled": "h-ct8",
  "buttonText": "nwNfe",
  "slimLayout": "zQkHa",
  "contentText": "_9n5y9"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
